/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online Markdown table generator. Type into a grid, choose per-column alignment, and copy a clean GitHub-flavored Markdown table. Works in your browser.`)
};

const es_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador gratuito de tablas Markdown en línea. Escribe en una cuadrícula, elige la alineación por columna y copia una tabla Markdown limpia compatible con GitHub. Funciona en tu navegador.`)
};

const de_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Markdown-Tabellengenerator. Geben Sie Daten in ein Raster ein, wählen Sie die Ausrichtung pro Spalte und kopieren Sie eine saubere GitHub Flavored Markdown-Tabelle. Funktioniert direkt in Ihrem Browser.`)
};

const nl_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online Markdown-tabelgenerator. Typ in een raster, kies per-kolom uitlijning en kopieer een schone GitHub Flavored Markdown-tabel. Werkt in uw browser.`)
};

const fr_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de tableau Markdown en ligne gratuit. Tapez dans une grille, choisissez l'alignement par colonne et copiez un tableau Markdown GitHub Flavored propre. Fonctionne dans votre navigateur.`)
};

const it_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore online gratuito di tabelle Markdown. Digitare in una griglia, scegliere l'allineamento per colonna e copiare una tabella Markdown con flavour GitHub pulita. Funziona nel vostro browser.`)
};

const pt_br2_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de tabelas Markdown online gratuito. Digite em uma grade, escolha o alinhamento por coluna e copie uma tabela Markdown limpa compatível com GitHub. Funciona no seu navegador.`)
};

const pt_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de tabelas Markdown online gratuito. Digite numa grelha, escolha o alinhamento por coluna e copie uma tabela Markdown compatível com GitHub, limpa. Funciona no seu navegador.`)
};

const ja_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料オンライン Markdown テーブルジェネレーター。グリッドに入力し、列ごとの配置を選択して、きれいな GitHub 風 Markdown テーブルをコピーできます。ブラウザで動作します。`)
};

const zh_mt_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线 Markdown 表格生成器。在网格中输入内容，选择每列的对齐方式，即可复制整洁的 GitHub Flavored Markdown 表格。可在浏览器中使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_meta_description", locale)
	if (locale === "en") return en_mt_meta_description(inputs)
	if (locale === "es") return es_mt_meta_description(inputs)
	if (locale === "de") return de_mt_meta_description(inputs)
	if (locale === "nl") return nl_mt_meta_description(inputs)
	if (locale === "fr") return fr_mt_meta_description(inputs)
	if (locale === "it") return it_mt_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_mt_meta_description(inputs)
	if (locale === "pt") return pt_mt_meta_description(inputs)
	if (locale === "ja") return ja_mt_meta_description(inputs)
	return zh_mt_meta_description(inputs)
};